//引入AxiosReques
import axiosApi from '@/utils/AxiosReques'

/**
 * @description 获取轮播图
 * @returns Promise
 */
export const reqBanner = (params) => axiosApi.post('/api/Webapi/index', params)


/**
 * @description 获取公司信息
 * @returns Promise
 */
export const getCompany = (params) => axiosApi.post('/api/Webapi/getCompany', params)

/**
 * @description 获取公司简介图片
 * @returns Promise
 */
export const getCompanyBrief = (params) => axiosApi.post('/api/Webapi/getCompanyBrief', params)


/**
 * @description 获取发展历程图片
 * @returns Promise
 */
export const getCompanyHistory = (params) => axiosApi.post('/api/Webapi/getCompanyHistory', params)

/**
 * @description 获取荣誉资质图片
 * @returns Promise
 */
export const getQualification = (params) => axiosApi.post('/api/Webapi/getQualification', params)

/**
 * @description 团队风采
 * @returns Promise
 */
export const getTeamSpirit = (params) => axiosApi.post('/api/Webapi/getTeamSpirit', params)

/**
 * @description 合作客户
 * @returns Promise
 */
export const getPartner = (params) => axiosApi.post('/api/Webapi/getPartner', params)

/**
 * @description 人才招聘
 * @returns Promise
 */
export const getTalent = (params) => axiosApi.post('/api/Webapi/getTalent', params)

/**
 * @description 联系顾问
 * @returns Promise
 */
export const getContact = (params) => axiosApi.post('/api/Webapi/getContact', params)


/**
 * @description 获取二级分类图片
 * @returns Promise
 */
export const getMenuBrand = (params) => axiosApi.post('/api/Webapi/getMenuBrand', params)


/**
 * @description 获取账单列表
 * @returns Promise
 */
export const getBill = (params) => axiosApi.post('/api/Webapi/getBill', params)

/**
 * @description 获取案例展示
 * @returns Promise
 */
export const getCaseInfos = (params) => axiosApi.post('/api/Webapi/getCaseInfo', params)


/**
 * @description 获取行业动态
 * @returns Promise
 */
export const getArticleInfo = (params) => axiosApi.post(`/api/Webapi/getArticleInfo?p=${params.page}`, params)

/**
 * @description 获取行业动态
 * @returns Promise
 */
export const getArticleDetails = (params) => axiosApi.get(`/api/Webapi/getArticleDetails`, params)

/**
 * @description countCustomerVisits
 * @returns Promise
 * @params id
 */
export const countCustomerVisits = (params) => axiosApi.post(`/api/Webapi/wts_pc`, params)